import { useSandboxStatus } from '../../features/sandbox/api.js';

const DEFAULT_MESSAGE =
  'Sandbox — this is a training environment. Data is temporary and may be reset at any time; ' +
  'email and integrations (QuickBooks, Microsoft 365, ClickUp) are disabled.';

/**
 * Persistent banner shown to everyone when the API reports it is running as the disposable
 * sandbox. Non-blocking (unlike the maintenance overlay) so trainees can freely explore.
 * Renders nothing on the production deployment.
 */
export function SandboxNotice(): JSX.Element | null {
  const { data } = useSandboxStatus();

  if (!data?.enabled) {
    return null;
  }

  const message = data.message?.trim() || DEFAULT_MESSAGE;

  return (
    <div className="flex flex-wrap items-center justify-center gap-2 bg-indigo-600 px-4 py-2 text-center text-sm font-medium text-white">
      <span className="rounded bg-white/20 px-1.5 py-0.5 text-xs font-semibold uppercase tracking-wide">
        Sandbox
      </span>
      <span>{message}</span>
    </div>
  );
}
